/**
 * Cliente API de documentos.
 *
 * Vista vecino (Sprint 12 S12-09): GET /vecino/documentos/ retorna
 * los documentos vigentes hoy (backend filtra por fechas).
 *
 * Vista comision (Sprint 13 S13-06, migrado desde frontend-superadmin):
 * listar admin con incluir_no_vigentes, crear nuevo, retirar
 * (PATCH vigente_hasta).
 */
import { apiFetch } from './client';
import type { DocumentoCreate, DocumentoRead, TipoDocumento } from './types';

export function listarDocumentosVecino(
  opts: { tipo?: TipoDocumento } = {},
): Promise<DocumentoRead[]> {
  const params = new URLSearchParams();
  if (opts.tipo) params.set('tipo', opts.tipo);
  const qs = params.toString();
  return apiFetch<DocumentoRead[]>(
    `/vecino/documentos/${qs ? `?${qs}` : ''}`,
  );
}

export function listDocumentosAdmin(opts: {
  tipo?: TipoDocumento;
  incluir_no_vigentes?: boolean;
} = {}): Promise<DocumentoRead[]> {
  const params = new URLSearchParams();
  if (opts.tipo) params.set('tipo', opts.tipo);
  if (opts.incluir_no_vigentes) params.set('incluir_no_vigentes', 'true');
  const qs = params.toString();
  return apiFetch<DocumentoRead[]>(`/documentos/${qs ? `?${qs}` : ''}`);
}

export function crearDocumento(
  data: DocumentoCreate,
): Promise<DocumentoRead> {
  return apiFetch<DocumentoRead>('/documentos/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function retirarDocumento(
  documentoId: string,
  vigenteHasta: string,
): Promise<DocumentoRead> {
  return apiFetch<DocumentoRead>(`/documentos/${documentoId}`, {
    method: 'PATCH',
    body: JSON.stringify({ vigente_hasta: vigenteHasta }),
  });
}
